<template>
  <div>
    <base-page-heading title="Compliance Documents">
      <template #extra>
        <b-button
          v-if="$can('create', 'ComplianceDocument')"
          v-b-modal.compliance-document-add-modal
          variant="primary"
          v-b-tooltip.hover
          title="Create a new Compliance Document"
        >
          <i class="fa fa-plus" />
          <span class="ml-1 d-none d-md-inline">New Document</span>
        </b-button>

        <b-dropdown
          variant="outline-secondary"
          right
          v-b-tooltip.hover
          title="Download spreadsheets"
        >
          <template #button-content>
            <b-spinner
              v-if="downloading"
              small
              label="Downloading..."
            />
            <i
              v-else
              class="fa fa-download"
            />
            <span class="ml-1 d-none d-md-inline">Downloads</span>
          </template>
          <b-dropdown-item @click="downloadSpreadsheet">
            Compliance Documents
          </b-dropdown-item>
          <b-dropdown-item
            @click="downloadCoveragesSpreadsheet"
            v-if="$can('read', 'ComplianceDocumentCoverage')"
          >
            Coverages
          </b-dropdown-item>
          <b-dropdown-item
            @click="downloadVerificationsSpreadsheet"
            v-if="$can('read', 'ComplianceDocumentVerification')"
          >
            Verification History
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </base-page-heading>
    <div class="content">
      <b-row>
        <b-col>
          <compliance-documents-list-filter
            :columns="columns"
            :initial-filters="filters"
            @filters-applied="applyFilters"
          />
        </b-col>
      </b-row>

      <compliance-documents-table
        :filters="filters"
        :columns="columns"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
      />
    </div>

    <!-- Page Modals -->
    <compliance-document-new-modal v-if="$can('create', 'ComplianceDocument')" />
  </div>
</template>

<script>
import ComplianceDocumentNewModal from '@/components/admin/complianceDocuments/NewModal.vue';
import ComplianceDocumentsTable from '@/components/admin/complianceDocuments/Table.vue';
import ComplianceDocumentsListFilter from '@/components/admin/complianceDocuments/ListFilter.vue';
import listMixin from '@/mixins/listMixin';
import downloadMixin from '@/mixins/downloadMixin';
import { COMPLIANCE_DOCUMENT_TABLE_NAME } from '@/constants/complianceDocuments';

export default {
  name: 'ComplianceDocumentsList',
  components: {
    ComplianceDocumentNewModal,
    ComplianceDocumentsTable,
    ComplianceDocumentsListFilter,
  },
  mixins: [downloadMixin, listMixin],
  props: {
    text: String,
    document_type: String,
    number: String,
    status: String,
    category: String,
    manager_id: String,
    phone: String,
    email: String,
    state: String,
    user_id: String,
    end_date_from: String,
    end_date_to: String,
    verified: String,
    active: String,
  },
  data() {
    return {
      tableName: COMPLIANCE_DOCUMENT_TABLE_NAME,
      filters: {
        text: this.text,
        document_type: this.document_type,
        number: this.number,
        status: this.status,
        category: this.category,
        manager_id: this.manager_id,
        phone: this.phone,
        email: this.email,
        state: this.state,
        user_id: this.user_id,
        end_date_from: this.end_date_from,
        end_date_to: this.end_date_to,
        verified: this.verified,
        active: this.active,
      },
    };
  },
  methods: {
    downloadSpreadsheet() {
      this.download(this.$complianceDocumentsAPI.getSpreadsheet, this.filters, 'Compliance Documents.csv');
    },
    downloadCoveragesSpreadsheet() {
      this.download(
        this.$complianceDocumentCoveragesAPI.getSpreadsheet,
        this.filters,
        'Compliance Document Coverages.csv'
      );
    },
    downloadVerificationsSpreadsheet() {
      this.download(
        this.$complianceDocumentVerificationsAPI.getSpreadsheet,
        this.filters,
        'Compliance Document Verifications.csv'
      );
    },
  },
};
</script>
